import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import './DesktopMessage.css';

// Shown instead of the app on wide screens: the app is made for phones.
export default function DesktopMessage() {
  const [isDesktop, setIsDesktop] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const checkDesktop = () => {
      setIsDesktop(window.innerWidth > 768);
    };

    checkDesktop();
    window.addEventListener('resize', checkDesktop);

    return () => window.removeEventListener('resize', checkDesktop);
  }, []);

  if (!isDesktop) {
    return null;
  }

  const address = window.location.host;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.origin);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Copy failed:', error);
    }
  };

  return (
    <div className="desktop-message">
      <div className="desktop-message__container">
        <img className="desktop-message__logo" src="/icon-192.png" alt="ruben" />
        <h1 className="desktop-message__title">Відкрийте на телефоні</h1>
        <p className="desktop-message__text">
          ruben створений для мобільних пристроїв.
          <br />
          Наведіть камеру телефона на код або відкрийте адресу вручну.
        </p>
        <div className="desktop-message__qr">
          <QRCodeSVG value={window.location.origin} size={176} level="M" fgColor="#1f1f1f" bgColor="#ffffff" />
        </div>
        <div className="desktop-message__address">{address}</div>
        <button type="button" className="desktop-message__copy" onClick={copyLink}>
          {copied ? 'Скопійовано' : 'Скопіювати посилання'}
        </button>
      </div>
    </div>
  );
}
